import { useMemo } from 'react'
import useOffer from 'hooks/Offers/useOffer'
import { usePlaceById } from 'hooks/usePlace'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'

function useSearchTargetName(filters?: App.OfferListFilters): string | undefined {
  const propertyId = filters?.propertyId
  const placeId = filters?.landmarkId ?? filters?.destinationId

  const listKey = useMemo(() => filters ? getOfferListKey(filters) : '', [filters])

  const matchingOfferId = useAppSelector(state => {
    if (!listKey) return undefined
    const offerList = state.offer.offerLists[listKey]
    const metaData = state.offer.searchResultMetadata.offerMetaData[listKey]
    if (!offerList || !metaData) return undefined
    return offerList.offerIds.find(id => metaData[id]?.isMatchingProperty)
  })

  const [offer] = useOffer<App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary>(
    matchingOfferId,
    { disabled: !matchingOfferId, requireSummaryOnly: true },
  )

  const place = usePlaceById(placeId, !!propertyId || !placeId)

  if (offer) return offer.property.name
  return place?.name
}

export default useSearchTargetName
